// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoContent_container__xIFCz","pageTag":"VideoContent_pageTag__3GrCW","videoBadge":"VideoContent_videoBadge__1NUzX"};